import { extend } from 'lodash';
/**
   * @ngdoc service
   * @name adjust.service:RightSidebar
   *
   * @description
   * Right sidebar service for the {@link adjust.directive:rightSidebar rightSidebar} directive
   *
   */
function RightSidebar() {
  'ngInject';
  /**
  * @ngdoc property
  * @name _defaults
  * @propertyOf adjust.service:RightSidebar
  *
  * @description
  * Default sidebar parameters
  *
  * @type {Object}
  * @private
  */
  var _defaults = {
    open: false,
    theme: 'light',
    size: 'medium',
    dismiss: true
  };

  /**
  * @ngdoc property
  * @name _theme
  * @propertyOf adjust.service:RightSidebar
  *
  * @description
  * Theme of the sidebar
  *
  * @type {string}
  * @private
  */
  var _theme = _defaults.theme;

  /**
  * @ngdoc property
  * @name _size
  * @propertyOf adjust.service:RightSidebar
  *
  * @description
  * Size of the sidebar
  *
  * @type {string}
  * @private
  */
  var _size = _defaults.size;

  /**
  * @ngdoc property
  * @name _dismiss
  * @propertyOf adjust.service:RightSidebar
  *
  * @description
  * Dismiss flag
  *
  * @type {boolean}
  * @private
  */
  var _dismiss = _defaults.dismiss;

  return {
    init: init,
    getTheme: getTheme,
    setTheme: setTheme,
    getSize: getSize,
    setSize: setSize,
    isDismissible: isDismissible,
    setDismissible: setDismissible,
    checkDismissible: checkDismissible,
    reset: reset
  };

  /**
  * @ngdoc method
  * @name init
  * @methodOf adjust.service:RightSidebar
  *
  * @description
  * Initiate right sidebar with proper settings
  *
  * @param {Object} params parameters to override default options
  */
  function init(params) {

    var options = angular.copy(_defaults);

    extend(options, params || {});

    setDismissible(options.dismiss);
    setSize(options.size);
    setTheme(options.theme);

  }

  /**
  * @ngdoc method
  * @name getTheme
  * @methodOf adjust.service:RightSidebar
  *
  * @description
  * Get the current theme
  *
  * @returns {string} current theme
  *
  */
  function getTheme() {

    return _theme;

  }

  /**
  * @ngdoc method
  * @name setTheme
  * @methodOf adjust.service:RightSidebar
  *
  * @description
  * Set the current theme
  *
  * @param {string} theme theme to set
  */
  function setTheme(theme) {

    _theme = theme;

  }

  /**
  * @ngdoc method
  * @name getSize
  * @methodOf adjust.service:RightSidebar
  *
  * @description
  * Get the current size
  *
  * @returns {string} current size
  *
  */
  function getSize() {

    return _size;

  }

  /**
  * @ngdoc method
  * @name setSize
  * @methodOf adjust.service:RightSidebar
  *
  * @description
  * Set the current size
  *
  * @param {string} size size to set
  */
  function setSize(size) {

    _size = size;

  }

  /**
  * @ngdoc method
  * @name isDismissible
  * @methodOf adjust.service:RightSidebar
  *
  * @description
  * Check if sidebar can be dismissed
  *
  * @returns {string} current dismiss flag
  *
  */
  function isDismissible() {

    return _dismiss;

  }

  /**
  * @ngdoc method
  * @name setDismissible
  * @methodOf adjust.service:RightSidebar
  *
  * @description
  * Set dismiss flag for the sidebar
  *
  * @param {boolean} dismiss current dismiss flag
  */
  function setDismissible(dismiss) {

    _dismiss = dismiss;

  }

  /**
  * @ngdoc method
  * @name checkDismissible
  * @methodOf adjust.service:RightSidebar
  *
  * @description
  * Set dismissible state depending on dirty state
  *
  * @param {boolean} isDirty is dirty state
  * @private
  */
  function checkDismissible(isDirty) {

    setDismissible(!isDirty);

  }

  /**
  * @ngdoc method
  * @name reset
  * @methodOf adjust.service:RightSidebar
  *
  * @description
  * Reset to default options
  *
  * @private
  */
  function reset() {

    _theme = _defaults.theme;
    _size = _defaults.size;
    _dismiss = _defaults.dismiss;

  }
}

export { RightSidebar };
